import {
  EDO_VENDOR,
  TECHNICAL_PURPOSE,
  DidomiUtils,
} from '../utils/DidomiUtils';

export const isAllowed = (storage, key) => {
  const { vendor, purposes } = DidomiUtils.getValuesInPropertiesFromKey(
    storage,
    key
  );
  const isTechnical =
    vendor === EDO_VENDOR &&
    purposes.length === 1 &&
    purposes[0] === TECHNICAL_PURPOSE;
  let isAllowed = isTechnical;

  if (!isTechnical && vendor && purposes.length > 0) {
    const userStatus = DidomiUtils.getUserStatus();
    const isConsentCollected = DidomiUtils.isConsentCollected(userStatus);
    const isVendorAllowed = DidomiUtils.isVendorAllowed(vendor, userStatus);
    const isPurposesAllowed = DidomiUtils.isPurposesAllowed(
      purposes,
      userStatus
    );
    isAllowed = isConsentCollected && isVendorAllowed && isPurposesAllowed;
  }
  return isAllowed;
};
